module.exports = __webpack_public_path__ + "static/media/info-author.87101d64.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resources/info/info-author.gif
// module id = 1745
// module chunks = 0